export default __webpack_public_path__ + "static/worker2-f6808e4f4e1c1d2d1590d582a7a24804.jpeg";